import React from 'react'

//* HOC's
import withUIContext from 'context/consumerHOC/UIConsumer'

//* Components
import Page from 'components/common/Page'
import Container from 'components/common/Container'
import ButtonSimple from 'components/common/Buttons/ButtonSimple'
import Image from 'components/common/Image'
import Text from 'components/common/Text'
import ContactUsForm from 'components/pages/Forms/ContactUs'

//* Style
import ContactUsStyle from 'styles/pages/ContactUsStyle'


const ContactUs = ({ contactPopupIsOpen, toggleContactPopup, disableDomScroll, winWidth }) => {
    return (
        <ContactUsStyle>
            <Container>
                <Page className={'contact-us flexBoxColumn'}>
                    <ContactUsForm className={contactPopupIsOpen} />
                    <div className='top flexBox'>
                        <div className='left flexBoxColumn'>
                            <Text tag={'h1'} className='h1 NewYork' text='Contact our Support and Sales team' />
                            <Text tag={'p'} className='sub PopReg h9' text='Need to get in touch with the team? We’re all ears.' />
                            <ButtonSimple
                                text='Contact Us'
                                onClick={() => {
                                    toggleContactPopup()
                                    winWidth > 1200 && disableDomScroll()
                                }}
                            />
                        </div>
                        <Image src='/images/contact/contact_us.webp' />
                    </div>
                    <div className='middle flexBoxColumn'>
                        <Text tag={'p'} className='NewYork h10' text='Who do you need to get in touch with?' />
                        <div className='block flexBox spaceBetween'>
                            <div className='single-block flexBoxColumn'>
                                <Text tag={'p'} className='title PopSemi h11' text='Sales' />
                                <Text tag={'span'} className='PopReg h4'>
                                    <span>
                                        Interested in learning more about Oplos?
                                        <br /> Contact us at{' '}
                                    </span>
                                    <span>
                                        <a href='mailto:sales@oplos.com'>sales@oplos.com</a>
                                    </span>
                                </Text>
                            </div>
                            <div className='single-block flexBoxColumn'>
                                <Text tag={'p'} className='title PopSemi h11' text='General Questions' />
                                <Text tag={'span'} className='PopReg h4'>
                                    <span>
                                        Have a general question for us?
                                        <br /> Contact us at{' '}
                                    </span>
                                    <span>
                                        <a href='mailto:sales@oplos.com'>info@oplos.com</a>
                                    </span>
                                </Text>
                            </div>
                        </div>
                    </div>
                    <div className='bottom'>
                        <div className='popup'>
                            <Text tag={'p'} className='NewYork h10' text='Oplos on Map' />
                            <Text tag={'p'} className='address PopReg h12' text='301 Howard St. #600 San Francisco, CA 94105' />
                            <ButtonSimple
                                text='Contact Us'
                                onClick={() => {
                                    toggleContactPopup()
                                    winWidth > 1200 && disableDomScroll()
                                }}
                            />
                        </div>
                        <Image src='/images/contact/map.webp' />
                    </div>
                </Page>
            </Container>
        </ContactUsStyle>
    )
}

export default withUIContext(ContactUs, ['contactPopupIsOpen', 'toggleContactPopup', 'disableDomScroll', 'winWidth'])
